let OSS = require('ali-oss')

let client = new OSS({
    region: 'oss-cn-beijing',
    accessKeyId: 'LTAIfCEuOpo4cPfh',
    accessKeySecret: 'ZcBUlOKPqp0vzwkZCGSdmFQsS6HGN6',
    bucket: 'sgitns-com-bucket',
    secure:true,
});
export default {
    // async  put (file) {
    //     try {
    //         let result = await client.put('/UploadFile/ClientFiles/LOGO/test.png', file);
    //         console.log(result);
    //     } catch (e) {
    //         console.log(e);
    //     }
    // }
    uploadFile(src,file,callback) {
        client.put(src, file).then(function (res) {
            // console.log('put success: %j', res);
            res.linkurl='https://oss.sgitns.com/'+res.name
            callback(res)
            console.log(res);
        }).catch(function (err) {
            callback(err)
            console.error('error: %j', err);
        });
    }
    
}
// put();